import * as React from 'react';
import Card from '@mui/joy/Card';
import CardCover from '@mui/joy/CardCover';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import dayjs from 'dayjs';
import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded';
import { useNavigate } from 'react-router-dom';
import { Button, IconButton, Stack } from '@mui/joy';
import { ChevronRight } from '@mui/icons-material';

type EventHighlightCardProps = {
  title: string;
  location: string;
  imageUrl: string;
  date: Date;
  href: string;
  compact: boolean;
};

export const EventHighlightCard = (props: EventHighlightCardProps) => {
  const { date, imageUrl, location, title, href, compact } = props;
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Card
      sx={{
        width: 'full',
        cursor: 'pointer',
        paddingY: compact ? '1rem' : '2rem',
      }}
      onClick={() => navigate(href)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardCover>
        <img src={imageUrl} srcSet={imageUrl} loading="lazy" alt="" />
      </CardCover>
      <CardCover
        sx={{
          background: isHovered
            ? 'linear-gradient(to top, rgba(0,0,0,0.05), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0) 300px)'
            : 'linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0) 300px)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      />
      <CardContent sx={{ justifyContent: 'flex-end' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Stack gap={1}>
            <Typography level="title-lg" textColor="#fff">
              {title}
            </Typography>
            {!compact && (
              <Typography
                startDecorator={<LocationOnRoundedIcon />}
                textColor="neutral.300"
              >
                {location}
              </Typography>
            )}
            <Typography
              startDecorator={<DateRangeRoundedIcon />}
              textColor="neutral.300"
              level="body-sm"
            >
              {dayjs(date).fromNow()}
            </Typography>
          </Stack>
          <IconButton>
            <ChevronRight
              sx={{
                color: '#fff',
              }}
            />
          </IconButton>
        </Stack>
      </CardContent>
    </Card>
  );
};
